import { find, trim } from 'lodash';

import { placeholderEmailRegex } from 'common/constants/regex';

const NO_CONTACT_CHOSEN = {
  email: undefined,
  phoneNumber: undefined,
  isDefaultEmailShown: false,
  isDefaultPhoneShown: false,
  isPlaceholderEmailShown: false,
};

// The email and phone this order's partner notifies the patient on, chosen the way the backend
// does: the partner's own value, or the patient's default email / mobile phone when it has none.
// Each field falls back on its own, and a placeholder email counts as none. A placeholder default
// is shown but never emailed. With isDefaultContactShown off, a missing value stays empty.
const choosePartnerContactForOrder = ({ patient, partnerUuid, isDefaultContactShown }) => {
  if (!patient) return NO_CONTACT_CHOSEN;

  const partnerContact = partnerUuid
    ? find(patient.contactsFromPartners, { partnerId: partnerUuid })
    : undefined;
  const hasOwnEmail = !!partnerContact?.email && !partnerContact.hasPlaceholderEmail;
  const hasOwnPhone = !!partnerContact?.phoneNumber;
  const isDefaultEmailShown = !hasOwnEmail && !!isDefaultContactShown;
  const isDefaultPhoneShown = !hasOwnPhone && !!isDefaultContactShown;
  const email = hasOwnEmail ? partnerContact.email : undefined;
  const phoneNumber = hasOwnPhone ? partnerContact.phoneNumber : undefined;

  return {
    email: isDefaultEmailShown ? patient.email : email,
    phoneNumber: isDefaultPhoneShown ? patient.mobilePhone : phoneNumber,
    isDefaultEmailShown,
    isDefaultPhoneShown,
    isPlaceholderEmailShown: isDefaultEmailShown && placeholderEmailRegex.test(trim(patient.email)),
  };
};

export default choosePartnerContactForOrder;
